// extracted by mini-css-extract-plugin
export default {"input":"Input_input__pS6ZV","inputDisabled":"Input_inputDisabled__Y+OoV"};